import { Grid } from '@chakra-ui/react';
import React from 'react';
import {
    Button, Image, Text,
} from 'shared';
import {
    LuBookOpen, LuCakeSlice, LuChefHat, LuMartini, LuTruck, LuPhone, LuMail,
} from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLinkPageState } from '../model';

export const LinkPage = () => {
    const {
        logoImage, socialMedias, phone, email, contacts,
    } = useLinkPageState();

    return (
        <Grid height="100vh" width="100vw" position="relative">
            <Helmet>
                <title>Социальные сети и контакты Corso Catering</title>
                <meta name="description" content="Социальные сети и контакты Corso Catering" />
                <meta property="og:title" content="Социальные сети и контакты Corso Catering" />
            </Helmet>
            {/* <Image
                src={mainImage?.url}
                position="absolute"
                height="100vh"
                width="100vw"
                objectFit="cover"
            /> */}
            <Grid width="100vw" position="relative" zIndex={2} backdropFilter="blur(10px)">
                <Grid
                    margin="auto"
                    width={{
                        base: '80vw',
                        lg: '30vw',
                    }}
                    padding="2rem"
                >
                    <Grid gap="1rem">
                        <Grid margin="0 auto" background="#ffffff" pos="relative" width="70%">
                            <Image src={logoImage?.url} width="100%" />
                        </Grid>
                        <Grid gap="0.5rem">
                            <Text margin="auto" fontSize="3rem">Контакты</Text>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = `tel:${phone}`; }}>
                                <LuPhone />
                                Позвонить нам
                            </Button>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = `mailto:${email}`; }}>
                                <LuMail />
                                Написать на почту
                            </Button>
                            {contacts.map((contact) => (
                                <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = contact.link || ''; }}>
                                    <Image src={contact.image?.url} height="1.5rem" />
                                    {contact.title}
                                </Button>
                            ))}
                        </Grid>
                        <Grid gap="0.5rem">
                            <Text margin="auto" fontSize="3rem">Разделы</Text>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = '/catering'; }}>
                                <LuBookOpen />
                                Событийный кейтеринг
                            </Button>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = '/delivery'; }}>
                                <LuTruck />
                                Доставка готовых блюд
                            </Button>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = '/culinary-studio'; }}>
                                <LuChefHat />
                                Кулинарная анимация
                            </Button>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = '/outdoor-bars'; }}>
                                <LuMartini />
                                Выездные бары
                            </Button>
                            <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = '/sweet-shop'; }}>
                                <LuCakeSlice />
                                Кондитерская
                            </Button>
                        </Grid>
                        <Grid gap="0.5rem">
                            <Text margin="auto" fontSize="3rem">Социальные сети</Text>
                            <Grid gap="1rem" margin="0 auto">
                                {socialMedias.filter(
                                    ({ showMobile }) => !showMobile,
                                ).map((socialMedia) => (
                                    <Link to={socialMedia.link} target="_blank">
                                        <Grid margin="0 auto" width="fit-content" templateColumns="auto 1fr" gap="0.5rem">
                                            <Image margin="auto 0" src={socialMedia.image.url} height="1.5rem" />
                                            <Text fontSize="1.5rem">{socialMedia.name}</Text>
                                        </Grid>
                                    </Link>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
